import { useState } from "react";

export function useValidationErrors<T extends object>() {
  const [errors, setErrors] = useState<Partial<Record<keyof T, string>>>({});

  const setApiErrors = (errorObj: any) => {
    const newErrors: Partial<Record<keyof T, string>> = {};
    if (errorObj && typeof errorObj === "object") {
      for (const key in errorObj) {
        if (Array.isArray(errorObj[key])) {
          newErrors[key as keyof T] = errorObj[key][0].replace(
            /<[^>]*>?/gm,
            ""
          );
        }
      }
    }
    setErrors(newErrors);
  };

  const clearError = (key: keyof T) => {
    setErrors((prev) => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
  };

  return {
    errors,
    setApiErrors,
    clearError,
    setErrors,
  };
}
